import React, {Component} from "react";

import axios from 'axios';
import history from '../../../history';
import Constants from '../../../components/Constants/';
import FileBase64 from 'react-file-base64';
import Select from 'react-select';

import {
    Row,
    Col,
    Button,
    Label,
    Input,
    Link,
    Table,
    Badge
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import AlertContainer from 'react-alert';

class DoctorForm extends Component {

  constructor(props) {
    super(props);

    this.refreshDoctor = this.refreshDoctor.bind(this);
    this.updateInputValue = this.updateInputValue.bind(this);
    this.updateUserInputValue = this.updateUserInputValue.bind(this);
    this.updateCheckboxValue = this.updateCheckboxValue.bind(this);
    this.onImageSelect = this.onImageSelect.bind(this);

    this.onGroupSelect = this.onGroupSelect.bind(this);
    this.getDoctorGroupsStr = this.getDoctorGroupsStr.bind(this);
    this.saveDoctor = this.saveDoctor.bind(this);

    this.state = {
        doctorId: this.props.match.params.doctorId,
        doctor: null,
        groupList: [],
        value: [],
        doctorGroups: []
    };
      /*
      * Configurações do alerta
      */
      this.alertOptions = {
        offset: 14,
        position: 'top right',
        theme: 'light',
        time: 10000,
        transition: 'scale'
      }
    }

    componentDidMount(){

      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/group'
      })
      .then(response => {

        let groupsList = [];
        response.data.forEach(function(group) {
          groupsList.push({
            value: group.id,
            label: group.name
          });
        });

        this.setState({groupList: groupsList});

      });


      this.refreshDoctor();
    }

    refreshDoctor(){

      if(this.props.match.params.doctorId == null ){

        let blankDoctor = {
          id: null,
          name: "",
          crm: "",
          phone: "",
          alternativePhone: "",
          mobile: "",
          alternativeMobile: "",
          email: "",
          alternativeEmail: "",
          status: "ACTIVE",
          signature: "",
          signatureFileName: "",

          user: {
            userName: "",
            password: ""
          }
        };

        this.setState({
            doctor: blankDoctor
        });

      }else{
        axios({
            method: 'get',
            url: Constants.apiUrl+'/api/v1/doctor/'+this.props.match.params.doctorId
        })
        .then(response => {
            this.setState({
                doctor: response.data
            });
        });

        axios({
            method: 'get',
            url: Constants.apiUrl+'/api/v1/group/doctor/'+this.props.match.params.doctorId
        })
        .then(response => {

          let actualDoctorGroups = [];
          response.data.forEach(function(group) {
            actualDoctorGroups.push(group.id);
          });

          this.setState({
              doctorGroups: actualDoctorGroups
          });
        });


      }
    }

    saveDoctor(){

      let errorMessages = "";
      if(this.state.doctor.name == ""){
        errorMessages += "O campo Nome é obrigatório. \r\n";
      }
      if(this.state.doctor.user.userName == ""){
        errorMessages += "O campo Usuário é obrigatório. \r\n";
      }
      if(this.state.doctor.user.password == ""){
        errorMessages += "O campo Senha é obrigatório. \r\n";
      }

      if(errorMessages != ""){
        this.msg.show(errorMessages, {
          time: 10000,
          type: 'success'
        });

        return false;
      }

      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/doctor',
          data: this.state.doctor
      })
      .then(response => {
          history.replace("doctors");
      });
    }

    updateInputValue(evt, input) {
      let actualDoctor = this.state.doctor;
      actualDoctor[input] = evt.target.value;

      this.setState({
        doctor: actualDoctor
      });
    }

    updateCheckboxValue(evt, input) {
      let actualDoctor = this.state.doctor;
      actualDoctor[input] = !actualDoctor[input];

      this.setState({
        doctor: actualDoctor
      });
    }

    updateUserInputValue(evt, input) {
      let actualDoctor = this.state.doctor;
      actualDoctor.user[input] = evt.target.value;

      this.setState({
        doctor: actualDoctor
      });
    }

    onImageSelect(file) {
      let actualDoctor = this.state.doctor;
	  let signature = file.base64.replace("data:image/JPEG;base64,", "").replace("data:image/jpeg;base64,", "").replace("data:image/png;base64,", "");
      actualDoctor.signature = signature;
      actualDoctor.signatureFileName = file.name;
      this.setState({doctor: actualDoctor});
    }

    onGroupSelect (value) {
      let actualDoctorGroups = this.state.doctorGroups;

      let tokens = value.split(',');

      //adicionar
      if(tokens.length > actualDoctorGroups.length){
        if(tokens[tokens.length-1] != "" && tokens[tokens.length-1] != undefined){
          actualDoctorGroups.push(tokens[tokens.length-1]);
          //Adiciona médico ao Grupo
          console.log(this.state.doctor.id);
          axios({
              method: 'post',
              headers: {
                  'Content-Type': 'text/plain'
              },
              url: Constants.apiUrl+'/api/v1/group/addDoctor/'+tokens[tokens.length-1],
              data: this.state.doctor.id
          })
          .then(response => {
            this.msg.show("Grupo adicionado ao médico.", {
              time: 10000,
              type: 'success'
            });
          });
        }
      }else if(tokens.length < actualDoctorGroups.length || (tokens.length == actualDoctorGroups.length && tokens[0] == "")){

        actualDoctorGroups.forEach(function(group) {
          if(tokens.indexOf(group) < 0){
            actualDoctorGroups.splice(actualDoctorGroups.indexOf(group), 1);
            //Remove médico do Grupo
            axios({
                method: 'delete',
                url: Constants.apiUrl+'/api/v1/group/removeDoctor/'+group+'/'+this.state.doctor.id
            })
            .then(response => {
              this.msg.show("Grupo removido deste médico.", {
                time: 10000,
                type: 'success'
              });
            });
          }
        }, this);
      }

      this.setState({
        doctorGroups: actualDoctorGroups
      });
  	}

    getDoctorGroupsStr(){
      let str = "";
      this.state.doctorGroups.forEach(function(group) {
        if(str != ""){
          str += ","+group;
        }else{
          str += group;
        }
      });
      return str;
    }


    render() {

      if(this.state.doctor == null) return null;

      return(
          <div>
            <h2>Médico</h2>
            <hr />
            <Row>
              <Col xs="6" md="6">
                  <Label>Nome</Label>
                  <Input type="text" id="name" ref="name" value={this.state.doctor.name}
                    onChange={evt => this.updateInputValue(evt, "name")} placeholder="Nome"/>
              </Col>

              <Col xs="6" md="3">
                <Label>CRM</Label>
                <Input type="text" id="crm" ref="crm" value={this.state.doctor.crm}
                  onChange={evt => this.updateInputValue(evt, "crm")} placeholder="CRM"/>
              </Col>

              <Col xs="6" md="3">
                  <Label htmlFor="resident"></Label>
                  <Input type="checkbox" id="resident" value={this.state.doctor.resident}
                    checked={this.state.doctor.resident}
                    onChange={evt => this.updateCheckboxValue(evt, "resident")}/> Residente
              </Col>
            </Row>

            <hr />
            <Row>
              <Col xs="6" md="4">
                <Label>Telefone</Label>
                <Input type="text" id="phone" ref="phone" value={this.state.doctor.phone}
                  onChange={evt => this.updateInputValue(evt, "phone")} placeholder="Telefone"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Tel. Alternativo</Label>
                <Input type="text" id="alternativePhone" ref="alternativePhone" value={this.state.doctor.alternativePhone}
                  onChange={evt => this.updateInputValue(evt, "alternativePhone")} placeholder="Tel. Alternativo"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Celular</Label>
                <Input type="text" id="mobile" ref="mobile" value={this.state.doctor.mobile}
                  onChange={evt => this.updateInputValue(evt, "mobile")} placeholder="Celular"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Cel. Alternativo</Label>
                <Input type="text" id="alternativeMobile" ref="alternativeMobile" value={this.state.doctor.alternativeMobile}
                  onChange={evt => this.updateInputValue(evt, "alternativeMobile")} placeholder="Cel. Alternativo"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Email</Label>
                <Input type="text" id="email" ref="email" value={this.state.doctor.email}
                  onChange={evt => this.updateInputValue(evt, "email")} placeholder="Email"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Email Alternativo</Label>
                <Input type="text" id="alternativeEmail" ref="alternativeEmail" value={this.state.doctor.alternativeEmail}
                  onChange={evt => this.updateInputValue(evt, "alternativeEmail")} placeholder="Email Alternativo"/>
              </Col>
            </Row>
            <hr />


            <hr />
            <Label>Assinatura</Label>
            <br />
            {
              this.state.doctor.signature ?
              <img src={"data:image/JPEG;base64,"+this.state.doctor.signature} className="img img-responsive" />
              : null
            }
            {'\u00A0'}{'\u00A0'}
            <FileBase64
              multiple={ false }
              onDone={ this.onImageSelect } />

            <hr />
            <Row>
              <Col xs="6" md="4">
                <Label>Usuário</Label>
                <Input type="text" id="username" ref="username" value={this.state.doctor.user.userName}
                  onChange={evt => this.updateUserInputValue(evt, "userName")} placeholder="Usuário"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Senha</Label>
                <Input type="password" id="password" ref="password" value={this.state.doctor.user.password}
                  onChange={evt => this.updateUserInputValue(evt, "password")} placeholder="Senha"/>
              </Col>

              <Col xs="6" md="4">
                <Label>Status</Label>

                <select className="form-control" onChange={evt => this.updateInputValue(evt, "status")} value={this.state.doctor.status}>
                  <option value="ACTIVE">Ativo</option>
                  <option value="INACTIVE">Inativo</option>
                </select>
              </Col>
            </Row>

            <div className={this.props.match.params.doctorId == null ? "hidden" : ""}>
              <hr />
              <Label>Grupos</Label>
              <br />
              <Select
      					closeOnSelect={false}
      					multi
      					onChange={this.onGroupSelect}
      					options={this.state.groupList}
      					placeholder="Grupos"
                removeSelected={true}
                simpleValue
  					    value={this.getDoctorGroupsStr()}
      				/>
              <br />
            </div>

            <br />
            <Button color="success" onClick={() => { this.saveDoctor(); }}>Salvar Médico</Button>
            <br />
            <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
            <br />
          </div>
        )
    }
}

export default DoctorForm;



// WEBPACK FOOTER //
// ./src/views/admin/DoctorForm/DoctorForm.js